import { NavigationGuard } from "vue-router/types/router";

import store from "@/store";
import { jwtRefreshTokenKey, jwtService } from "@/jwt";

import { AuthenticationResponse } from "@/interfaces/authentication-response";

import { RouterPathName } from "@/enums/router-path-name.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Authentication JWT guard.
 * It redirects to authentication page if current JWT is not valid or expired.
 */
export const jwtGuard: NavigationGuard = (to, from, next) => {
  const isAuthenticated = jwtService.isTokenValid && !jwtService.isTokenExpired;

  if (to.name !== RouterPathName.Authenticate && !isAuthenticated) {
    // Redirect not logged user who tried to enter main app view to authentication page
    window.location.href = `${process.env.VUE_APP_LEGACY_APP_URL}/no-auth-v2.php`;
  } else if (to.name === RouterPathName.Authenticate && isAuthenticated) {
    // Redirect logged in user who tried to enter authentication form to main app view
    next({ name: RouterPathName.AppMain });
  } else {
    if (!from.name && !!to.name && isAuthenticated) {
      // Handle main app view refresh when user is logged in
      store.commit("auth/authSuccess", {
        token: jwtService.tokenString,
        refreshToken: localStorage.getItem(jwtRefreshTokenKey)
      } as AuthenticationResponse);
    }
    next();
  }
};
